const ibcParser = {
  parseCivilState: (code) => {
    switch (code) {
      case '1':
        return {code: 'S', name: 'Solteiro'};
      case '2':
        return {code: 'C', name: 'Casado'};
      case '3':
        return {code: 'R', name: 'Divorciado'};
      case '4':
        return {code: 'J', name: 'Separado Judicialmente'};
      case '5':
        return {code: 'V', name: 'Viúvo'};
      default:
        return {code: '', name: ''};
    }
  },
};

export default ibcParser;
